import type { JSX } from 'react'
import type { IInputProps } from '../Input'

import { TextBoxTypes } from 'atoms/TextBox'
import { Input } from '../Input'
import {
  InputBorders,
  InputFontColors,
  InputFonts,
  InputNames,
  InputPaddings,
} from '../Input.h'

export interface ILoginUsernameInputProps extends IInputProps {}

export const LoginUsernameInput = ({
  type = 'text',
  name = InputNames.Username,
  placeholder = '',
  placeholderColor = InputFontColors.TEXT_ICON_SECONDARY,
  label = '',
  labelFont = TextBoxTypes.Caption4,
  font = InputFonts.Body4,
  colorDefault = InputFontColors.TEXT_ICON_PRIMARY,
  required = true,
  paddings = InputPaddings.SIZE_20,
  borders = InputBorders.BORDER_10,
  inputWrapperWidth = '100%',
  inputWrapperHeight = '40px',
  autoComplete,
  ...rest
}: ILoginUsernameInputProps): JSX.Element => (
  <Input
    type={type}
    name={name}
    placeholder={placeholder}
    placeholderColor={placeholderColor}
    label={label}
    font={font}
    colorDefault={colorDefault}
    required={required}
    paddings={paddings}
    borders={borders}
    labelFont={labelFont}
    inputWrapperWidth={inputWrapperWidth}
    inputWrapperHeight={inputWrapperHeight}
    autoComplete={autoComplete}
    {...rest}
  />
)
